import { getPathSegmentsFromPathname } from './getPathSegmentsFromPathname';

interface GetDetailsFromSignupRouteResult {
  pageGroup: 'me' | 'pets';
  cardName: string;
  petName: string | null;
}

/**
 * @example
 * `/signup/me/me1` returns `{ cardName: 'me1', petName: null }`
 * `/signup/pets/Fido/petWeight` returns `{ cardName: 'petWeight', petName: 'Fido' }`
 */
export function getDetailsFromSignupRoute(
  path: string,
  search: string
): GetDetailsFromSignupRouteResult {
  // TODO: Remove after September 15, 2025
  // Backwards compatibility for old routes for vet emails that were formatted
  // as /signup/me/:email?card=GetStarted&referredByVet=...
  const searchParams = new URLSearchParams(search);
  const cardFromSearchParams = searchParams.get('card');
  if (
    cardFromSearchParams === 'GetStarted' &&
    searchParams.has('referredByVet')
  ) {
    return {
      pageGroup: 'me',
      cardName: cardFromSearchParams,
      petName: null,
    };
  }
  // ^ Backwards compatibility for old routes for vet emails

  const pathSegments = getPathSegmentsFromPathname(path);

  // pathSegments[0] is "signup"
  const pageGroup = pathSegments[1] as 'me' | 'pets';
  const isPetsPageGroup = pageGroup === 'pets';
  const cardName = isPetsPageGroup ? pathSegments[3] : pathSegments[2];
  const petName = isPetsPageGroup ? pathSegments[2] : null;

  return {
    pageGroup,
    cardName,
    petName,
  };
}
